import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MainListComponent} from "./main-list/main-list.component";
import {FileManagerShellComponent} from "./file-manager-shell/file-manager-shell.component";
import {ShellComponent} from "./shell/shell.component";
import {RouteGuard} from "./route.guard";
import {LoginComponent} from "./login/login.component";


const routes: Routes = [
  {
    path: '',
    canActivate: [RouteGuard],
    component: ShellComponent,
    children: [
      {
        path: '',
        component: FileManagerShellComponent
      },
      {
        path: 'download',
        component: MainListComponent
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [RouteGuard]
})
export class RootRoutingModule { }
